import { useUser } from '../../../hooks/useUser';
import { useMessages } from '../../../hooks/useMessages';

export const OpenChats = () => {
  const { setChatMessages, chatMessages, listOfOpenChats, setActiveChatId, setActiveOpenChat } =
    useMessages();

  const { user } = useUser();

  const handleMessageSelection = (indexPosition: number) => {
    setChatMessages(listOfOpenChats[indexPosition].messages);
    setActiveChatId(listOfOpenChats[indexPosition].chat_id);
    setActiveOpenChat(listOfOpenChats[indexPosition]);
  };

  return (
    <div id="users-list-of-open-chats">
      <div className="messages-list">
        {listOfOpenChats.map((chat, i) => {
          return (
            <p
              key={`${chat.chat_id}-${i}`}
              className={
                chatMessages[0]?.chat_id !== undefined &&
                listOfOpenChats[i].chat_id === chatMessages[0].chat_id
                  ? 'message-thread-item active'
                  : 'message-thread-item'
              }
            >
              <strong
                key={`user-chat-id-${i}`}
                className="user-chat-list"
                onClick={() => handleMessageSelection(i)}
              >
                {chat.user_1 === user?.username ? chat.user_2 : chat.user_1}
              </strong>
            </p>
          );
        })}
      </div>
    </div>
  );
};
